export const VIRTUAL_ORDERS = 'PINES VIRTUALES'
